module.exports = __webpack_public_path__ + "img/label_green_building.5ab58ab1.png";